import { jwtDecode } from 'jwt-decode'

/**
 * Decodes a JSON Web Token (JWT) using the provided certificate.
 *
 * @param {string} cert - The certificate used to decode the JWT.
 * @returns {Function} A function that takes a JWT string as input and returns the decoded token.
 * @throws {Error} Throws an error if the JWT cannot be decoded.
 */
export const decodeJwt = cert => data => {
  const decoded = jwtDecode(data, cert, { algorithms: ['RS512'] })
  return decoded
}
